module.exports = __webpack_public_path__ + "static/media/icon_2.bd966d14.svg";